import { useAsync, type AsyncState } from "@/components/useAsync";
import { fetchPrivateResponse } from "@/data/interventionsRepository";
import type { QuestionnaireResponse } from "@/domain/questionnaire";

/** Loads an intervention's private questionnaire response when `enabled`. */
export function usePrivateResponse(
  interventionId: string | undefined,
  enabled: boolean,
): AsyncState<QuestionnaireResponse | null> {
  const key = enabled && interventionId ? interventionId : null;
  const [state] = useAsync(key, () => fetchPrivateResponse(interventionId!));
  return state;
}
